import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ServicesGrid = () => {
  const services = [
    {
      icon: 'ri-file-list-3-line',
      title: 'Psychiatric Evaluations',
      description: 'Comprehensive assessments to understand your mental health needs and develop personalized treatment plans tailored to your unique situation.',
    },
    {
      icon: 'ri-medicine-bottle-line',
      title: 'Medication Management',
      description: 'Expert oversight of psychiatric medications with regular monitoring, adjustments, and education to ensure optimal therapeutic outcomes.',
    },
    {
      icon: 'ri-home-heart-line',
      title: 'Flexible Care Delivery',
      description: 'Choose from in-office visits, secure telepsychiatry sessions, or convenient house calls to receive care in the setting that works best for you.',
    },
  ];

  return (
    <section className="py-24 bg-beige-light">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <motion.p
            className="text-xs uppercase tracking-widest text-neutral-gray/60 mb-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            What We Offer
          </motion.p>
          <motion.h2
            className="text-4xl md:text-5xl font-bold text-neutral-gray"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            Comprehensive Mental<br />Health Services
          </motion.h2>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 cursor-pointer group"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -8 }}
            >
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className={`${service.icon} text-5xl text-primary group-hover:text-primary-dark transition-colors`}></i>
              </div>
              <h3 className="text-2xl font-bold text-neutral-gray mb-4">
                {service.title}
              </h3>
              <p className="text-neutral-gray/70 leading-relaxed">
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>

        {/* View All Button */}
        <motion.div
          className="text-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
        >
          <Link
            to="/services"
            className="inline-flex items-center space-x-2 border-2 border-primary text-primary hover:bg-primary hover:text-white px-8 py-3 rounded-full font-semibold transition-all cursor-pointer whitespace-nowrap"
          >
            <span>View All Services</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesGrid;